import PropTypes from 'prop-types';
import React from 'react';

import { theme } from 'src/styles/theme';

const SVG = ({ color }) => (
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
      fillRule="evenodd"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M11 5L5 11" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5 5L11 11" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

SVG.propTypes = {
  color: PropTypes.string,
};

SVG.defaultProps = {
  color: theme.palette.common.gray500,
};

export default SVG;
